<template>
  <div>
    <Matriz/>
  </div>
</template>
<script>
import Matriz from '../components/matriz/matriz.vue'

export default {
   components:{
     Matriz
   }
}
</script>
